var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1517"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 363",
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.389 22v-2.5H4.778v-1.667h2.5V6.167h-2.5V4.5h3.611V2h1.667v2.5h3.056V2h1.666v2.583a3.984 3.984 0 012.417 1.472 4.128 4.128 0 01.611 4.153 4.278 4.278 0 01-.889 1.375 4.208 4.208 0 012.306 3.75 4.149 4.149 0 01-4.167 4.167h-.278V22h-1.667v-2.5h-3.055V22zm.556-10.833h5a2.393 2.393 0 001.778-.736 2.493 2.493 0 00-1.778-4.264h-5zm0 6.667h6.111a2.393 2.393 0 001.778-.736 2.493 2.493 0 00-1.778-4.264H8.945z",
    fill: "#444"
  }))));
}
export default SvgChain;